export const fontFaces = [
  {
    fontFamily: 'PxGrotesk',
    fontStyle: 'normal',
    fontWeight: '400',
    src: `url("https://design.fuel.network/fonts/Px-Grotesk-Regular.otf"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Regular.woff") format("woff"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Regular.woff2") format("woff2")`,
  },
  {
    fontFamily: 'PxGrotesk',
    fontStyle: 'italic',
    fontWeight: '400',
    src: `url("https://design.fuel.network/fonts/Px-Grotesk-Italic.otf"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Italic.woff") format("woff"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Italic.woff2") format("woff2")`,
  },
  {
    fontFamily: 'PxGrotesk',
    fontStyle: 'normal',
    fontWeight: '600',
    src: `url("https://design.fuel.network/fonts/Px-Grotesk-Bold.otf"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Bold.woff") format("woff"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Bold.woff2") format("woff2")`,
  },
  {
    fontFamily: 'PxGrotesk Mono',
    fontStyle: 'normal',
    fontWeight: '400',
    src: `url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Regular.otf"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Regular.woff") format("woff"),
      url("https://design.fuel.network/fonts/Px-Grotesk-Mono-Regular.woff2") format("woff2")`,
  },
];
